'use client';

import React from 'react';
import BodyWidth from '@/components/layout/body-width/BodyWidth';
import Main from '@/components/layout/base/Main';
import { AuthProvider } from '@/context/auth';
import { UserPropsType } from '@/types/auth';

type Props = {
  footer?: React.ReactNode;
  needViewPort?: boolean;
  outContainerEle?: React.ReactElement;
  isHideUser?: boolean;
} & UserPropsType;

const Layout = (props: Props) => {
  const { children, user, needViewPort, outContainerEle, isHideUser } = props;

  if (!children) return null;

  return (
    <>
      <BodyWidth needViewPort={needViewPort} />
      <AuthProvider user={user}>
        <Main
          isHideHeader={isHideUser}
          outContainerEle={outContainerEle}
          isSalaryLink={false}
        >
          {children}
        </Main>
      </AuthProvider>
    </>
  );
};

export default Layout;
